module.exports = __webpack_public_path__ + "img/_pelota_red.58d447bb.jpg";